import React, { FunctionComponent } from 'react';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '../';

const BrassIconNationality: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faGlobeAmericas} />;

export { BrassIconNationality };
